import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { HelperService } from './helper.service';

@Injectable()
export class SessionService {

  email: string;
  token: string;
  id: any;
  role_id: any;
  first_name: string;
  last_name: string;
  job_title: string;
  free_trial_mode: string;
  subscription_start_date: string;
  free_trail_days_left: number;
  expTime: any;
  rememberMe: boolean;
  validSession: boolean = true;
  subscriptionMode: any;
  showDialog: number;

  constructor(public storage: Storage,private helperService:HelperService) { }

  async setStorageDetails(data, rememberMe: boolean, resetPwd?) {
    this.validSession = true;
    //console.log(data);
    if (data.role_id == 50) {
      this.storage.set('token', data.token);
      this.storage.set('id', data.id);
      this.storage.set('email', data.work_email);
      this.storage.set('first_name', data.first_name);
      this.storage.set('last_name', data.last_name);
      this.storage.set('role_id', data.role_id);
    } else if(data == "resetPwd"){      
      this.storage.set('id', resetPwd.id);
      this.storage.set('email', resetPwd.work_email);
      this.storage.set('first_name', resetPwd.first_name);
      this.storage.set('last_name', resetPwd.last_name);
      this.storage.set('isPwdExpired', resetPwd.isPwdExpired);
    }else {
      this.storage.set('token', data.token);
      let decodedTokenData
      await this.helperService.decode(data.token).then((d)=>{
        decodedTokenData=d;
        this.storage.set('role_id', decodedTokenData.role.role_id);
      })
      this.storage.set('id', data.id);
      this.storage.set('email', data.work_email);
      this.storage.set('first_name', data.first_name);
      this.storage.set('last_name', data.last_name);
      this.storage.set('free_trial_mode', data.free_trial_mode);
      this.storage.set('job_title', data.job_title);
      this.storage.set('company_logo_id', data.company_logo);
      this.storage.set('profile_image_id', data.profile_image);
      this.storage.set('showDialog', data.showDialog);
      if(data.copilot_conversation_id){
        this.storage.set('copilot_conversation_id',data.copilot_conversation_id);
      }
      if (data.free_trail_days_left) {
        this.storage.set('free_trail_days_left', data.free_trail_days_left);
      }
    }
    this.storage.set('expTime', data.expTime);

    if (rememberMe == true) {
      this.storage.set('rememberMe', true);
    } else {
      this.storage.set('rememberMe', false);
    }
    this.token = data.token;
    this.id = data.id;
    this.email = data.work_email;
    this.first_name = data.first_name;
    this.last_name = data.last_name;
    this.job_title = data.job_title;
    this.free_trial_mode = data.free_trial_mode;
    this.expTime = data.expTime;
    this.free_trail_days_left = data.free_trail_days_left;
    this.rememberMe = rememberMe;
    this.showDialog = data.showDialog;
  }

  async getStorageDetails() {
    this.storage.get('vendor');
    this.token = await this.storage.get('token');
    this.expTime = await this.storage.get('expTime');
    this.rememberMe = await this.storage.get('rememberMe');
    this.id = await this.storage.get('id');
    this.email = await this.storage.get('email');
    this.first_name = await this.storage.get('first_name');
    this.last_name = await this.storage.get('last_name');
    this.job_title = await this.storage.get('job_title');
    this.free_trial_mode = await this.storage.get('free_trial_mode');
    this.free_trail_days_left = await this.storage.get('free_trail_days_left');
    this.role_id = await this.storage.get('role_id');
  }

  updateStorageDetails(data) {
    this.storage.set('token', data.token);
    this.storage.set('id', data.id);
    this.storage.set('email', data.email);
    this.storage.set('first_name', data.first_name);
    this.storage.set('last_name', data.last_name);
    this.storage.set('expTime', data.expTime);

    this.token = data.token;
    this.id = data.id;
    this.email = data.work_email;
    this.first_name = data.first_name;
    this.last_name = data.last_name;
    this.expTime = data.expTime;
   // window.location.reload()
  }

  checkUserLoggedIn() {
    let token;
    this.storage.get("token").then((res) => {
      token = res;
    })
    if (token) {
      return true;
    } else {
      return false;
    }
  }

  async getStorage() {
    let data = {
      token: await this.storage.get("token"),
      userId: await this.storage.get("id"),
      showDialog: await this.storage.get("showDialog"),
      pytokenDataSource: await this.storage.get("pytoken_data_source"),
      pytokenDataOperation: await this.storage.get("pytoken_data_operation"),
      pytokenEmailOperation: await this.storage.get("pytoken_email_operation"),
      pytokenPycodeOperation: await this.storage.get("pytoken_pycode_operation"),
      pytokenJdbcOperation: await this.storage.get("pytoken_jdbc_operation")
    }
    return data;
  }


  clearStorage() {
    this.storage.clear();
    this.token = "";
    this.expTime = "";
    let storedVersion = localStorage.getItem('currentVersion')
    localStorage.clear();
    if (storedVersion) {
      localStorage.setItem('currentVersion', storedVersion);
    }
  }

  // storeUserDetails(user, isLocalStorage, subscriptionMode:any=false) {
  //   // this.rememberMe = isLocalStorage;
  //   // this.validSession = true;
  //   if (isLocalStorage) {
  //     localStorage.setItem('work_email', user.work_email);
  //     localStorage.setItem('id', user.id);
  //     localStorage.setItem('token', user.token);
  //     localStorage.setItem('first_name', user.first_name);
  //     localStorage.setItem('last_name', user.last_name);
  //     localStorage.setItem('free_trial_mode', user.free_trial_mode);
  //     localStorage.setItem('subscription_start_date', user.subscription_start_date);
  //     localStorage.setItem('free_trail_days_left', user.free_trail_days_left);
  //     localStorage.setItem('expTime', user.expTime);
  //     localStorage.setItem('rememberMe', isLocalStorage);
  //     localStorage.setItem('subscriptionMode', subscriptionMode);
  //   } else {
  //     sessionStorage.setItem('work_email', user.work_email);
  //     sessionStorage.setItem('id', user.id);
  //     sessionStorage.setItem('token', user.token);
  //     sessionStorage.setItem('first_name', user.first_name);
  //     sessionStorage.setItem('last_name', user.last_name);
  //     sessionStorage.setItem('free_trial_mode', user.free_trial_mode);
  //     // localStorage.setItem('subscription_start_date', user.subscription_start_date);
  //     sessionStorage.setItem('subscription_start_date', user.subscription_start_date);
  //     sessionStorage.setItem('free_trail_days_left', user.free_trail_days_left);
  //     sessionStorage.setItem('expTime', user.expTime);
  //     sessionStorage.setItem('rememberMe', isLocalStorage);
  //     sessionStorage.setItem('subscriptionMode', subscriptionMode);
  //   }
  //   // this.token = user.token;
  //   // this.email = user.work_email;
  //   // this.first_name = user.first_name;
  //   // this.last_name = user.last_name;
  //   // this.free_trial_mode = user.free_trial_mode;
  //   // this.subscription_start_date = user.subscription_start_date;
  //   // this.id = user.id;
  //   // this.expTime = user.expTime;
  //   // this.subscriptionMode = subscriptionMode;
  // }

  // updateUserDetails(user) {
  //   const token = sessionStorage.getItem('token');
  //   if (token) {
  //     sessionStorage.setItem('work_email', user.work_email);
  //     sessionStorage.setItem('id', user.id);
  //     sessionStorage.setItem('first_name', user.first_name);
  //     sessionStorage.setItem('last_name', user.last_name);
  //     sessionStorage.setItem('free_trial_mode', user.free_trial_mode);
  //     sessionStorage.setItem('subscriptionMode', user.subscriptionMode);
  //     sessionStorage.setItem('subscription_start_date', user.subscription_start_date);
  //     sessionStorage.setItem('expTime', user.expTime);
  //     user.token && sessionStorage.setItem('token', user.token);
  //   } else {
  //     localStorage.setItem('work_email', user.work_email);
  //     localStorage.setItem('id', user.id);
  //     localStorage.setItem('first_name', user.first_name);
  //     localStorage.setItem('last_name', user.last_name);
  //     localStorage.setItem('free_trial_mode', user.free_trial_mode);
  //     localStorage.setItem('subscriptionMode', user.subscriptionMode);
  //     localStorage.setItem('subscription_start_date', user.subscription_start_date);
  //     localStorage.setItem('expTime', user.expTime);
  //     user.token && localStorage.setItem('token', user.token);
  //   }
  // }

  // fetchUserDetailsFromStorage() {
  //   let work_email, id, token, expTime, loggedInStatus, last_name, first_name, free_trial_mode, subscription_start_date, rememberMe, subscriptionMode;
  //   token = sessionStorage.getItem('token');
  //   rememberMe = sessionStorage.getItem('rememberMe');

  //   if (!token) {
  //     work_email = localStorage.getItem('work_email');
  //     id = localStorage.getItem('id');
  //     token = localStorage.getItem('token');
  //     first_name = localStorage.getItem('first_name');
  //     last_name = localStorage.getItem('last_name');
  //     free_trial_mode = localStorage.getItem('free_trial_mode');
  //     subscriptionMode = localStorage.getItem('subscriptionMode');
  //     subscription_start_date = localStorage.getItem('subscription_start_date');
  //     expTime = localStorage.getItem('expTime');
  //   } else {
  //     work_email = sessionStorage.getItem('work_email');
  //     id = sessionStorage.getItem('id');
  //     first_name = localStorage.getItem('first_name');
  //     last_name = localStorage.getItem('last_name');
  //     free_trial_mode = localStorage.getItem('free_trial_mode');
  //     subscriptionMode = localStorage.getItem('subscriptionMode');
  //     subscription_start_date = localStorage.getItem('subscription_start_date');
  //     expTime = sessionStorage.getItem('expTime');
  //   }
  //   if (token) {
  //     // this.email = work_email;
  //     // this.id = id;
  //     // this.token = token;
  //     // this.first_name = first_name;
  //     // this.last_name = last_name;
  //     // this.free_trial_mode = free_trial_mode;
  //     // this.subscriptionMode = subscriptionMode;
  //     // this.subscription_start_date = subscription_start_date;
  //     // this.expTime = expTime;
  //     // this.rememberMe = rememberMe;
  //     loggedInStatus = true;
  //   }
  //   return loggedInStatus;
  // }



  // deleteSession() {
  //   for (var obj in localStorage) {
  //     if (localStorage.hasOwnProperty(obj)) {
  //       localStorage.removeItem(obj);
  //     }
  //   }
  //   for (var obj in sessionStorage) {
  //     if (sessionStorage.hasOwnProperty(obj)) {
  //       sessionStorage.removeItem(obj);
  //     }
  //   }
  //   this.storage.clear();
  // }
}
